import SharedAccountsApi from '@/services/configuration/SharedAccountsApi'
import {
  SharedAccountApp,
  SharedAccountGame,
  SharedAccountInterface,
} from './SharedAccount.types'

export class SharedAccountDTO implements SharedAccountInterface {
  id = ''
  username = ''
  email = ''
  app_id = ''
  app: SharedAccountApp | null = null
  linked_account_id: string | null = null
  borrowed_by_session_id: string | null = null
  borrowed_in_arena_id: number | null = null
  arena_ids: number[] = []
  games: SharedAccountGame[] = []
  banned = false
}

export default class SharedAccount extends SharedAccountDTO {
  static api = SharedAccountsApi

  constructor(DTO: SharedAccountDTO) {
    super()
    Object.assign(this, DTO)
  }
}
